import { SaveRetencion } from "../../shared/saveRetencion";

export interface CreateRetencionesPageInterface {}

const CreateRetencionesPage: React.FC<CreateRetencionesPageInterface> = () => {
  /* useCheckPermissions(PermissionsEnum.api_add_compra) */

  return <SaveRetencion titlePage="Crear retencion de compra" />;
};

export default CreateRetencionesPage;
